let imgServerUrl = "";
let imgSolvedServerUrl = "";

export function setImageServers(imgServer, imgSolvedServer){
	if(imgServer && imgSolvedServer){
		imgServerUrl = imgServer;
		imgSolvedServerUrl = imgSolvedServer;
	} else {
		throw Error("imgServer lub imgSolvedServer nie jest podany")
	}
}

export function getImageFromRiddle(riddle){
	if(riddle.isSolved && riddle.imgSolved){
		return _getSolvedImage(riddle.imgSolved)
	} else {
		return _getImage(riddle.img)
	}
}

function _getImage(name){
	return `${imgServerUrl}/${name}.png`
}

function _getSolvedImage(name){
	return `${imgSolvedServerUrl}/${name}.png`
}